import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ViewTable } from 'shared';
import { NAME_SPACE } from 'i18n';
import { useOperatorsBuildTable } from './useOperatorsBuildTable';

export const ViewOperators = ({ operators }) => {
  const { t } = useTranslation(NAME_SPACE.READER_REQUESTS);
  const { rows, headCells, getOperators } = useOperatorsBuildTable(operators, t);

  return (
    <ViewTable
      rows={rows}
      cells={headCells}
      mainKey={'name'}
      defaultOrderBy={{ property: 'name', direction: 'asc' }}
      defaultPageSize={5}
      onFetchData={getOperators}
      allowRowSelection={false}
      emptyText={t('operators.empty')}
      toolbar={{
        title: t('operators.name')
      }}
    />
  );
};

ViewOperators.propTypes = {
  operators: PropTypes.array.isRequired
};
